import { FC, useMemo } from 'react';
import { Button, ButtonVariant } from '@edikk-edikk/country-layout-black';
import { FavoriteToggleIcon, useAdvertCardContext, useFavoriteToggleControls } from '#advert/components/card';

const FavoriteToggle: FC = () => {
  const { isProcess, handlerClick } = useFavoriteToggleControls();
  const {
    advert: {
      isFavorite,
    },
  } = useAdvertCardContext();
  const ariaLabel = useMemo(
    () => (isFavorite ? 'Add to favorite' : 'Remove from favorite'),
    [isFavorite],
  );

  return (
    <Button variant={ButtonVariant.black} circle onClick={handlerClick} aria-label={ariaLabel}>
      <FavoriteToggleIcon isProcess={isProcess} />
    </Button>
  );
};

export { FavoriteToggle };
